import React,{ useState, useEffect } from "react";
import swal from 'sweetalert2';
import Select from "react-select";
// import * as helper from '../global/helper';
import { getStaggeredTemplateData, postStaggeredTemplate, deleteStaggeredTemplate } from "../api/teeTimeAPI"



const StaggeredTemplate = (props) => {

    const [pageData,            setPageData]           = useState({});
    const [isEdit,              setIsEdit]             = useState(false);
    const [isUpdate,            setIsUpdate]           = useState(false);

    const [allTemplates,        setAllTemplates]       = useState([]);
    const [newTemplate,         setNewTemplate]        = useState({ TeeBox:1 });

    //only for react-selects -->
    const [selectedMaster,      setSelectedMaster]     = useState();
    const [selectedBlock,       setSelectedBlock]      = useState();
    const [selectedTeeType,     setSelectedTeeType]    = useState();

    //#region Effects -->

    useEffect(() => {
        props.title("Staggered Template", "staggered-template");       
        fetchData();
        
        //Sorting Function -->
        AllowSortable();
    }, []);
    
    useEffect(() => {
        if(isEdit){
            $('#txtSlot').timepicker({
                minuteStep: 10,
                defaultTime: ''
            });
    
            $('#txtSlot').on('change',({target}) => dataHandler("Slot", target.value) );
        }
    },[isEdit])

   //#endregion 
      
    const fetchData = async() => {
        try {
            const {teeTimeTemplates, teeTimeBlocks, teeTimeMasters, teeTypes} = await getStaggeredTemplateData();         

            const firstTeeMasters = teeTimeMasters.flatMap(m => (m.TeeBox == 1)?({label: m.Name , value : m.ID, ...m}) : []);         
            const teeBlocks = teeTimeBlocks.map(b => ({label: b.Block , value : b.ID, ...b}));
            const transformedTeeTypes = teeTypes.map(teeType => ({ value: teeType.ID, label: teeType.Name }));
            
            setPageData({ firstTeeMasters, teeBlocks, teeTimeMasters , teeTimeTemplates, transformedTeeTypes});     
            
            if(firstTeeMasters.length > 0){
                onMasterChange(firstTeeMasters[0], teeTimeMasters, teeTimeTemplates, transformedTeeTypes);  
            }
        } catch (error) {
            swal.fire({ icon :'error', titleText : error.message })
        }
    }

    const getMasterForTeeBox = (teeBox) => {
        const master = pageData.teeTimeMasters.find(m => 
            m.StartDate == selectedMaster.StartDate && m.EndDate == selectedMaster.EndDate && m.TeeBox == teeBox
        );
        return master;
    };
    const postTemplate = () => {       
        // const btn  =  (!isEdit) ? $('#btnAdd') : $("#btnUpdate");
        const form = $('#addTemplateForm');
     
        form.validate({
            rules   : { ddlMaster: { required: true }, txtSlot: { required:true }, ddlBlock: { required: true }, ddlType: { required: true }},
            messages: { ddlMaster : { required: "Please select master" }, txtSlot:{ required: "Please select slot" } , ddlBlock : { required: "Please select block" }, ddlType: { required: "Please select a Type" }}
        });

        if (!form.valid()) return;
        
        //Validation Goes Here -->  
        const master1  =  selectedMaster;

        if(!selectedMaster) {
            swal.fire({ icon: "warning", titleText: 'Oops..', text: 'Please select master', buttonsStyling: false, confirmButtonClass: "btn btn-brand"});
            return;
        }

        const master10 = pageData.teeTimeMasters.find( f => f.StartDate === master1.StartDate && f.EndDate === master1.EndDate && f.ID !== master1.ID);
        const isExist  = allTemplates.find( f => (f.TeeTimeMasterID === master1.ID || f.TeeTimeMasterID === master10.ID) && f.TeeBox == newTemplate.TeeBox && f.Slot === newTemplate.Slot && f.TeeTypeID === selectedTeeType.value);
                     
        // if (t && ( isUpdate && t.ID != newTemplate.ID)) {
                  
        if ( ( !isUpdate && !!isExist)  || ( isUpdate && !!isExist && isExist.ID != newTemplate.ID)) {
            swal.fire({ icon: "warning", titleText: 'Oops..', text: 'Slot already exist!', buttonsStyling: false, confirmButtonClass: "btn btn-brand"});
            return;
        } 
        
        try {        
            if(!isUpdate) {
                // Create new tee time template
                newTemplate.TeeTimeMasterID = selectedMaster.ID
                newTemplate.TeeTimeBlockID  = selectedBlock.ID
                newTemplate.Index           = allTemplates.length + 1;
                newTemplate.TeeTypeID       = selectedTeeType.value;            
            }else{
                // Update existing tee time template
                //Allow to update block, teebox, slot -->
                const newMaster = getMasterForTeeBox(newTemplate.TeeBox);
                if (newMaster) {
                    newTemplate.TeeTimeMasterID = newMaster.ID;
                } 
                newTemplate.TeeTimeBlockID  = selectedBlock.ID
                newTemplate.TeeTypeID       = selectedTeeType.value;                   
            }

            //Calls API --
            saveTemplates([newTemplate]);

            if (newTemplate.ID) {            
                swal.fire({ toast: true, icon: 'success', position: 'bottom-end', showConfirmButton: false, timer: 2500,  
                    titleText: 'Template updated successfully!', 
                    onOpen: () => swal.hideLoading()                                     
                });
            }else{
                swal.fire({ icon: 'success', showConfirmButton: false, timer: 2500,
                    titleText: 'Template added successfully!',
                    onOpen: () => swal.hideLoading()    
                });
            }
                
            clearActions();
        } catch (err) {
            swal.fire({ icon: 'error', titleText: 'Error!', text: err.message, buttonsStyling: false, confirmButtonClass: 'btn btn-brand'});
            return;
        }        
    }
    
    const deleteHandler = async(templateId) => {
        if(!templateId) return;

        swal.fire({ titleText: 'Loading', text: 'Please Wait...', showConfirmButton: false, onOpen: () => swal.showLoading() });
        try {
            const res = await deleteStaggeredTemplate(templateId);
                        
            //Update and Refresh -->
            onMasterChange(selectedMaster, pageData.teeTimeMasters, res);        
            
            setPageData( d => {
                d.teeTimeTemplates = res;
                return {...d};
            });            
                                                
            swal.fire({ toast: true, icon: 'success', position: 'bottom-end', showConfirmButton: false, timer: 2500,  
                    titleText: 'Template deleted successfully!', 
                    onOpen: () => swal.hideLoading()                                     
            });
        } catch (err) {
            swal.fire({ icon: 'error', titleText: 'Error!', text: err.message, buttonsStyling: false, confirmButtonClass: 'btn btn-brand'});
            return;
        }
    }

    const saveTemplates = async(templates) => {
        if(templates.length <= 0) return;

        try {
            swal.fire({ titleText: 'Loading', text: 'Please Wait...', showConfirmButton: false, onOpen: () => swal.showLoading() });
                        
            const res = await postStaggeredTemplate(templates);
            
            //Update and Refresh -->
            onMasterChange(selectedMaster, pageData.teeTimeMasters, res);
            
            setPageData( d => {
                d.teeTimeTemplates = res;
                return {...d};
            });
                                    
            swal.close()
        } catch (err) {
            swal.close()
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
            return;  
        }
    }

    //#region Helpers --->
        const dataHandler = (field,value) => setNewTemplate(d => ({...d, [field]: value}));

        const editHandler = (id) => {                 
            setIsUpdate(true);
            const d = allTemplates.find( a => a.ID == id);
            const b = pageData.teeBlocks.find( a => a.ID == d.TeeTimeBlockID);
            const teeType = pageData.transformedTeeTypes.find(a => a.value == d.TeeTypeID);
            
            setNewTemplate(d);
            setSelectedBlock(b);
            setSelectedTeeType(teeType);
        
            $(`tr[data-id =${id}]`).addClass("bg-lightgrey");
        }
        
        const onMasterChange = (m, masterList = [], templateList = [], teeTypes = []) => {
            const {teeTimeMasters , teeTimeTemplates, transformedTeeTypes} = pageData;
            
            const mList = (!!masterList && (masterList.length > 0)) ?  masterList : teeTimeMasters || [];
            const tList = (!!templateList && (templateList.length > 0)) ?  templateList : teeTimeTemplates || [];    
                    
            const master1  =  m;
            const master10 = mList.find( f => f.StartDate === master1.StartDate && f.EndDate === master1.EndDate && f.ID !== master1.ID);   

            const filteredTemplates = tList.filter(i => i.TeeTimeMasterID === master1.ID || i.TeeTimeMasterID === master10.ID)
                    
            /** @todo 
            * Currently on Backend --> 
            * Update IsEdit Validation asper server date & teeTimePublish 
            */      
            setIsEdit(master1.IsEdit);
        
            setSelectedMaster(m);
            if (!master1.IsEdit) {
                const teeBox1WithWeekdayType = filteredTemplates.filter(i => i.TeeBox == 1 && i.TeeTypeID == 1);
                setAllTemplates(teeBox1WithWeekdayType);
            } else {
                setAllTemplates(filteredTemplates);
            }
            clearActions(transformedTeeTypes || teeTypes);
        }

        const onTeeBoxChange = (teeBoxValue) => {
            const teeTypeID = selectedTeeType.value;
            const { teeTimeTemplates } = pageData;
            const filteredTemplates = teeTimeTemplates.filter(i => i.TeeBox == teeBoxValue && i.TeeTypeID == teeTypeID);
            setAllTemplates(filteredTemplates);
            return;
        };

        const onTeeTypeChange = (teeTypeID) => {
            const teeBox = parseInt(newTemplate.TeeBox);
            const { teeTimeTemplates } = pageData;
            const filteredTemplates = teeTimeTemplates.filter(i => i.TeeTypeID == teeTypeID && i.TeeBox == teeBox);
            setAllTemplates(filteredTemplates);
            return;
        };

         //Sorting -->
         const AllowSortable =() =>{
            const config = (event, ui)=> {
                const ids = [];
                $('#table-block > tbody > .dragableRow').each((i,e) => ids.push( $(e).attr('data-id')));
                sortAndSave(ids);   
            }

            window.sortInit('#table-block tbody', config);    
        }

        const sortAndSave = async(param)=> {
            if(param.length <= 0) return;      
                        
            try {
                swal.fire({ titleText: 'Loading', text: 'Please Wait...', showConfirmButton: false, onOpen: () => swal.showLoading() });
                            
                let templates = [];        

                setAllTemplates( d => {
                    const sorted = [];
                    if(d.length > 0){                  
                        for (const [i,id] of Object.entries(param)) {                       
                            let f = d.find( a => a.ID == id);
                            if(!!f){
                                f.Index = parseInt(i)+1;                    
                                sorted.push(f);
                            }
                        }
                    
                        templates = sorted;
                        return d;
                    }
                });
                            
                if(templates.length > 0){                 
                    const res = await postStaggeredTemplate(templates);
                    setPageData( d => {
                        d.teeTimeTemplates = res;
                        return {...d};
                    });    
                }                   
                swal.close()
            } catch (err) {              
                swal.close()
                swal.fire({icon: 'error',titleText: 'Error!',text: err.message,buttonsStyling: false, confirmButtonClass: 'btn btn-brand'});
                return;  
            }
        }
        
        const clearActions = (teeTypes = {}) => {
            setIsUpdate(false);
            setNewTemplate({ TeeBox:1 });
            setSelectedBlock();
            setSelectedTeeType(teeTypes[0]);
            $("#table-block tbody tr").removeClass("bg-lightgrey");             
        }
    //#endregion

    const onCheck = async(value) => {
        saveTemplates([{...value, CheckBox: 'Y'}]);                  

    }

    return(
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content">
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet">
                        <div className="kt-portlet__body padding-t30 padding-b0">
                            <form className="kt-form" id="addTemplateForm" >                
                                <div id="ControlHolder" className="kt-form kt-form--label-right padding-10 bv-form" role="form">
                                    <div className="row align-items-center">
                                        <div className="form-group col-sm-2 d-flex align-items-center">
                                            <label className="col-form-label text-right mr-2 min-width-60">Master</label>
                                            <div className="input-group ddlCoursePnl flex-grow-1">
                                                <Select id="ddlMaster" name="ddlMaster" className="w-100" 
                                                    options={pageData.firstTeeMasters}
                                                    value={selectedMaster || ''} 
                                                    onChange={(v) => onMasterChange(v)}
                                                />
                                            </div>
                                        </div>
                                        {(!isEdit) && (<>
                                            <label className="col-sm-1 text-right pb-4 pnlAdd">Tee Box<span className="red">*</span></label>
                                            <div className="form-group col-sm-1 pnlAdd">
                                                <div className="input-group">
                                                    <select id="ddlTeeBox" name="ddlTeeBox" className="form-control"
                                                        value={newTemplate.TeeBox} onChange={({target}) => { 
                                                            dataHandler("TeeBox", target.value);
                                                            onTeeBoxChange(target.value);
                                                        }}
                                                    >
                                                        <option value="1">1</option>
                                                        <option value="10">10</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-group col-sm-2 d-flex align-items-center">
                                                <label className="col-form-label text-right mr-3 min-width-40">Type<span className="red">*</span></label>
                                                <div className="input-group flex-grow-1">
                                                    <Select id="ddlType" name="ddlType" className="w-100"
                                                    options={pageData.transformedTeeTypes}
                                                    value={ selectedTeeType || ''}
                                                    onChange={(v) => {
                                                        setSelectedTeeType(v);
                                                        onTeeTypeChange(v.value);
                                                        dataHandler("Type", v);
                                                    }}
                                                />
                                                </div>
                                            </div>
                                        </>)}
                                        {(isEdit) && (<>
                                            <div className="form-group col-sm-2 d-flex align-items-center">
                                                <label className="col-form-label text-right mr-3 min-width-40">Type<span className="red">*</span></label>
                                                <div className="input-group flex-grow-1">
                                                    <Select id="ddlType" name="ddlType" className="w-100"
                                                        options={pageData.transformedTeeTypes}
                                                        value={selectedTeeType || ''}
                                                        onChange={(v) => setSelectedTeeType(v)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group col-sm-2 d-flex align-items-center">
                                                <label className="col-form-label text-right mr-3 min-width-50">Block<span className="red">*</span></label>
                                                <div className="input-group flex-grow-1">                                           
                                                    <Select id="ddlBlock" name="ddlBlock" className="w-100" 
                                                        options={pageData.teeBlocks}
                                                        value={selectedBlock || ''} 
                                                        onChange={(v) => setSelectedBlock(v)} 
                                                    />
                                                </div>
                                            </div>
                                            <label className="col-sm-1 text-right pb-4 pnlAdd">Tee Box <span className="red">*</span></label>
                                            <div className="form-group col-sm-1 pnlAdd">
                                                <div className="input-group">
                                                    <select id="ddlTeeBox" name="ddlTeeBox" className="form-control"
                                                        value={newTemplate.TeeBox} onChange={({target}) => dataHandler("TeeBox", target.value)}
                                                    >
                                                        <option value="1">1</option>
                                                        <option value="10">10</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-group col-sm-4 pnlAdd d-flex">
                                                <label className="col-form-label  text-right pnlAdd width-55 margin-lr20"> Slot </label>
                                                <div className="input-group timepicker width-170  margin-r20">
                                                    <input id="txtSlot" name="txtSlot" type="text" className="form-control" 
                                                        readOnly={true} placeholder="Select time" 
                                                        value={ newTemplate.Slot || '' }                                               
                                                    />
                                                    <div className="input-group-append">
                                                        <span className="input-group-text height-38">
                                                            <i className="la la-clock-o"></i>
                                                        </span>
                                                    </div>
                                                </div>

                                                {(!isUpdate) ? (
                                                    <button id="btnAdd" type="button" className={`btn btn-label-brand d-inline-block margin-0  height-38`} onClick={postTemplate} ><i className="la la-plus"></i>Add</button>
                                                ):(
                                                    <div className="btn-group  height-38">
                                                        <button id="btnUpdate" type="button" className={`btn btn-label-success d-inline-block margin-0 `} onClick={postTemplate} > Update </button>
                                                        <button id="btnCancel" type="button" className="btn btn-secondary" onClick={clearActions}> <i className="la la-times ml-1 font-16" > </i> </button>
                                                    </div>
                                                )}
                                            </div>
                                        </>) }                                  
                                    
                                    </div>                                
                                </div>
                            </form>
                            <table id="table-block" className="table table-bordered table-hover margin-b30">
                                <thead className="light-grey-background">
                                    <tr>
                                        <th>Block</th>
                                        <th>Tee</th>
                                        <th>Type</th>
                                        <th>Slot</th>
                                        <th>Active</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(allTemplates.length > 0 )?
                                        allTemplates.map((t,i) => {
                                            return (<tr className="dragableRow" key={t.ID} data-id={t.ID}>
                                                <td>{t.Block}</td>
                                                <td>{t.TeeBox}</td>
                                                <td>{t.TeeTypeName}</td>
                                                <td>{t.Slot}</td>
                                                <td className="padding-0" width="15%">
                                                    <span className="kt-switch kt-switch--sm kt-switch--icon margin-lr10">
                                                        <label className="margin-b0 padding-t5">
                                                            <input 
                                                                id="chkActive" 
                                                                name="chkActive" 
                                                                type="checkbox" 
                                                                defaultChecked={t.Active == 'N' ? '' : 'checked'}
                                                                onChange={(event) => onCheck({...t, Active: event.target.checked ? 'Y' : 'N'})} 
                                                            />
                                                            <span></span>
                                                        </label>
                                                    </span>
                                                </td>
                                                <td className="text-center">
                                                    {(isEdit) && (<>
                                                        <button type="button" disabled={isUpdate} className="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs btn-block-edit mr-2"
                                                            onClick={() => editHandler(t.ID)}
                                                            >
                                                            <i className="flaticon2-edit"></i>
                                                        </button>
                                                        <button type="button" disabled={isUpdate} className="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs btn-block-edit"
                                                            onClick={() => deleteHandler(t.ID)}
                                                        >
                                                            <i className="flaticon2-rubbish-bin-delete-button"></i>
                                                        </button>                                                    
                                                    </>
                                                    )}
                                                </td>
                                            </tr>)
                                        }):
                                        (<tr><td colSpan={4}> 
                                            <div className="padding-10"> 
                                                <h5 className="text-center text-muted"> No Slots Available..! </h5> 
                                            </div>
                                        </td></tr>)
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default StaggeredTemplate;